import type { FaireProductEntity } from "../../entity_types/product";

export const p_pd474q2vga: FaireProductEntity = {
  token: "p_pd474q2vga",
  type: "product",
  name: "2.5 oz Vanilla Pumpkin Latte",
  brandName: "Candle Warmers Etc.",
  imageUrl:
    "https://cdn.faire.com/fastly/c72eb1042eddc19e6e3b230da99e599032aa697718fcee22b6ff980e490948d8.jpeg",
  priceDollars: 1.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/552cddc9c1b427d413f247f4d374d809a63a92678b58b7b1619e90897391b5fb.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
